import { Outlet } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters";
import "./Contact.scss";
/* eslint-disable unicode-bom */

function Contact() {
  const [letterClass, setLetterClass] = useState("text-animate");
  const [formStatus, setFormStatus] = useState("");
  const form = useRef();

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setFormStatus("sending");

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setFormStatus("success");
          setTimeout(() => setFormStatus(""), 3000);
          form.current.reset();
        },
        () => {
          setFormStatus("error");
          setTimeout(() => setFormStatus(""), 3000);
        }
      );
  };

  return (
    <>
      <div className="contact-page-wrapper">
        <span className="tags top-html">&lt;/html&gt;</span>
        <span className="tags top-tags">&lt;body&gt;</span>

        <div className="container contact-page">
          <div className="text-zone">
            <h1>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={["C", "o", "n", "t", "a", "c", "t", " ", "m", "e"]}
                idx={15}
              />
            </h1>
            <p>
              I'm actively seeking opportunities with leading technology
              companies where I can contribute to building impactful systems.
              If you have an exciting opportunity or just want to connect, feel
              free to reach out!
            </p>
            <div className="contact-form">
              <form ref={form} onSubmit={sendEmail}>
                <div className="ok">
                  <li className="half">
                    <input
                      placeholder="Name"
                      type="text"
                      name="name"
                      required
                    />
                  </li>
                  <li className="half">
                    <input
                      placeholder="Email"
                      type="email"
                      name="email"
                      required
                    />
                  </li>
                  <li>
                    <textarea
                      placeholder="Message"
                      name="message"
                      required
                    ></textarea>
                  </li>
                  <li>
                    <input
                      type="submit"
                      className="flat-button"
                      value={
                        formStatus === "sending"
                          ? "SENDING..."
                          : "SEND MESSAGE!"
                      }
                      disabled={formStatus === "sending"}
                    />
                  </li>
                  {formStatus === "success" && (
                    <li className="form-message success">
                      Message sent successfully!
                    </li>
                  )}
                  {formStatus === "error" && (
                    <li className="form-message error">
                      Failed to send. Please try again or email me directly.
                    </li>
                  )}
                </div>
              </form>
            </div>
          </div>
          <div className="contact-right-panel">
            <div className="contact-card">
              <div className="contact-card-icon">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <h3>Email Me</h3>
              <a href="mailto:anujrathore385@gmail.com">anujrathore385@gmail.com</a>
            </div>
            <div className="contact-card">
              <div className="contact-card-icon">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/>
                  <rect x="2" y="9" width="4" height="12"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </div>
              <h3>LinkedIn</h3>
              <a href="https://www.linkedin.com/in/anuj-rathore-a01960272/" target="_blank" rel="noreferrer">Connect with me</a>
            </div>
            <div className="contact-card">
              <div className="contact-card-icon">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/>
                </svg>
              </div>
              <h3>GitHub</h3>
              <a href="https://github.com/rathoreanuj" target="_blank" rel="noreferrer">View my repos</a>
            </div>
          </div>
        </div>

        <Outlet />
        <span className="tags bottom-tags">
          &lt;/body&gt;
          <br />
          <span className="bottom-tag-html">&lt;/html&gt;</span>
        </span>
      </div>
    </>
  );
}

export default Contact;